import { Tag } from '../../model/tagging/Tag';
import { ResourceEntityType, ResourceEntityTypeUtils } from '../../model/resources/ResourceEntityType';
import { Factory } from '../../services/Factory';

namespace app.controllers.project {

  export class ProjectDetailController {

    constructor(rootScope: IRootScope, private scope, private routeParams, uibModal, location: angular.ILocationService, private $timeout, private filter, private preferenceService: app.services.user.PreferenceService, private projectService: app.services.project.ProjectService,
                private organizationService: app.services.organization.OrganizationService, private collectionService: app.services.collections.CollectionService, exportService: app.services.exporting.ExportService, private tagService: app.services.tagging.TagService, tagCategoryService, exportDownloadService, navigationService,
                reportService: app.services.reporting.ReportService, preProcessingService: app.services.metrics.PreProcessingMetricsService, postProcessingService: app.services.metrics.PostProcessingMetricsService, notificationService: app.services.INotificationService,
                accountService: app.services.account.AccountService, private roleService: app.services.authentication.RoleService, private batchService: app.services.batching.BatchService, private reviewService: app.services.collections.ReviewService, processingService: app.services.processing.ProcessingService) {

      if (rootScope.currentProjectId && rootScope.currentProjectId != routeParams.projectId) {
        preferenceService.ResetGridPreferences(false);
      }

      rootScope.currentProjectId = routeParams.projectId;

      scope.roleService = roleService;
      navigationService.setActiveTab("projects");
      collectionService.ClearCurrentCollection();
      rootScope.$broadcast("navigation.batch.deselect");

      scope.OutputType = app.model.exporting.OutputType;
      scope.DisplayMode = app.model.user.DisplayMode;
      scope.Status = app.model.project.Status;
      scope.CollectionStatus = app.model.collections.CollectionStatus;
      scope.ResourceEntityType = ResourceEntityType;
      scope.resourceEntityTypes = ResourceEntityTypeUtils.ResourceEntityTypes;
      scope.resourceEntityType = {id: ResourceEntityType.Person, name: "Person"};
      scope.initializing = true;
      scope.numFilteredCollections = 0;

      scope.searchDocuments = () => {
        rootScope.$broadcast("BasicSearch.Triggered", "createdDate:" + app.services.search.basic.SearchService.FormatDateSearch({
          min: scope.chart.startDate,
          max: scope.chart.endDate
        }));
      };

      scope.setResourceEntityType = async item => {
        const fieldName = item.name.replace(" ", "").replace(item.name[0], item.name[0].toLowerCase());
        scope.resourceEntityType = item;

        scope.postprocessing.namedEntities = await postProcessingService.GetNamedEntities(routeParams.projectId, fieldName);
        scope.$applyAsync();
      };

      // Tag Pagination
      scope.tagPagination = {
        categoryId: null,
        limit: 20,
        page: 1,
        totalPages: 1,
        totalTags: 0
      };

      scope.tabSearch = {
        collection: ""
      };

      scope.projectSourceSize = 0;
      scope.projectOutputSize = 0;

      scope.exportDownloadService = exportDownloadService;
      scope.accountService = accountService;
      scope.reportService = reportService;

      scope.preprocessing = {
        selected: false,
        selection: "Extension",
        selections: ["Extension", "Category"]
      };

      scope.postprocessing = {
        selection: "Extension",
        selections: ["Extension", "Category", "Collection", "Custodian"],
        update: value => scope.postprocessing.communicationPatterns = postProcessingService.GetCommunicationPatterns(routeParams.projectId, value)
      };

      scope.review = {
        rows: [],
        columns: [],
        types: [],
        lastRecordedDate: 0,
        begin: 0,
        end: 0
      };

      // BATCH Pagination
      scope.batchPagination = {
        limit: 80,
        totalBatches: 0,
        pinnedTopRowData: [],
        pinnedBottomRowData: []
      };

      scope.reportPagination = {
        currentPage: 1,
        totalPages: 1,
        totalReports: 0,
        limit: 20
      };

      scope.resumeCollectionProcessing = (collection: any) => {
        (collection as any).resuming = true;
        processingService.ResumeProcessing(collection, () => {
          console.log("SUCCESS! " + collection);
          notificationService.addSuccess({
            title: "Resuming collection processing",
            description: "",
            timeout: 5000
          });
        }, () => {
          notificationService.addError({
            title: "Error resuming collection processing",
            description: "That's embarrassing, please try again later",
            timeout: 5000
          });
        });
      };

      scope.getReportsForList = () => {
        reportService.Find(
          routeParams.projectId,
          scope.reportPagination.currentPage - 1,
          scope.reportPagination.limit,
          scope.reportPagination.filterString || "",
          reportsPage => {
            scope.reportsPage = reportsPage;
            scope.reportPagination.currentPage = reportsPage.pageNumber + 1;
            scope.reportPagination.totalPages = reportsPage.totalPages;
            scope.reportPagination.totalReports = reportsPage.totalReports;
          });
      };

      scope.showFilteredCollections = text => {
        scope.tabIndex = 3;
        scope.tabSearch.collection = text;
      };

      scope.removeTag = tag => {
        const confirmModalInstance = uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/dialog_confirm.html",
          controller: "ConfirmModalCtrl",
          scope: scope,
          resolve: {
            title: () => "Delete Confirmation",
            message: () => `Are you sure you want to permanently delete the tag "${tag.name}"${scope.tagPagination.category.name === "Batch" ? " and all related batches " : ""}?`
          }
        });

        confirmModalInstance.result.then(result => {
          if (result === "ok") {

            this.DeleteAndRefreshTags(tag);

            notificationService.addSuccess({
              title: "Untagging Started",
              description: "Deleting tag " + tag.name + ".  We will notify you when it completes.",
              timeout: 2500
            });
          }
        });
      };

      scope.handleTagClick = tag => {
        preferenceService.CurrentFilter = {
          size: 1,
          projectId: scope.project.id,
          tags: {
            "and": [tag.id],
            "or": [],
            "not": []
          }
        };

        location.path("/project/" + scope.project.id + "/browse");
      };

      scope.saveSelectedCollections = _.debounce(() => scope.$apply(() => this.SaveSelectedCollections(scope)), 200);

      scope.checkAllCollections = () => {
        angular.forEach(scope.collections, collection => collection.checked = true);

        this.SaveSelectedCollections(scope);
      };

      scope.unCheckAllCollections = () => {
        angular.forEach(scope.collections, collection => collection.checked = false);

        this.SaveSelectedCollections(scope);
      };

      scope.openNewCollectionDialog = () => {
        uibModal.open({
          backdrop: "static",
          keyboard: true,
          backdropClick: false,
          templateUrl: "partials/dialog_collection.html",
          controller: "AddCollectionController",
          scope: scope,
          resolve: {
            project: () => scope.project
          },
          windowClass: "iio-large-modal"
        });
      };

      scope.openNewCustodianDialog = () => {
        uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/dialog_custodian.html",
          controller: "AddCustodianModalCtrl",
          scope: scope,
          resolve: {
            project: () => scope.project
          }
        });
      };

      scope.openNewExportDialog = () => {
        if (scope.project.status === Status.Trial) {
          uibModal.open({
            backdrop: "static",
            keyboard: true,
            backdropClick: false,
            templateUrl: "partials/dialog_credit_card.html",
            controller: "CreditCardModalController",
            scope: scope,
            resolve: {
              project: () => scope.project,
              message: () => "Activate account to turn on exports"
            }
          });
        } else {
          uibModal.open({
            backdrop: "static",
            keyboard: true,
            backdropClick: false,
            templateUrl: "partials/exporting/dialog_export.html",
            controller: "ExportController",
            scope: scope,
            resolve: {
              project: () => scope.project
            },
            windowClass: "iio-large-modal"
          });
        }
      };

      scope.openExportInfoDialog = exportInstance => {
        uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/exporting/dialog_export_info.html",
          controller: "ExportInfoController",
          scope: scope,
          resolve: {
            project: () => scope.project,
            exportObj: () => new app.model.exporting.Export(scope.project.id, {...exportInstance})
          },
          windowClass: "iio-large-modal"
        });
      };

      scope.openAssignBatchDialog = tag => {
        uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/batching/assign_batch.html",
          controller: "AssignBatchModalController",
          scope: scope,
          resolve: {
            project: () => scope.project,
            batch: () => tag
          }
        });
      };

      scope.openAddTagDialog = tag => {
        uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/tagging/dialog_add_tag.html",
          controller: "AddTagModalCtrl",
          scope: scope,
          resolve: {
            project: () => scope.project,
            tag: () => tag
          }
        });
      };

      scope.openPreProcessingReportDialog = () => {
        const currentDate = new Date();

        uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/reporting/dialog_report.html",
          controller: "AddReportModalCtrl",
          scope: scope,
          resolve: {
            project: () => scope.project,
            config: () => {
              return {
                type: "pre_processing_report",
                format: "zip",
                name: "Pre Processing Report " +
                  (currentDate.getMonth() + 1) + "/" +
                  currentDate.getDate() + "/" +
                  currentDate.getFullYear() + " @ " +
                  currentDate.getHours() + ":" +
                  currentDate.getMinutes() + ":" +
                  currentDate.getSeconds(),
                fields: []
              };
            },
            formConfig: () => {
              return {
                hideFields: true
              }
            },
            collections: null,
            search: null,
            filter: () => scope.cookieFilter
          }
        });
      };

      scope.openPostProcessingReportDialog = () => {
        const currentDate = new Date();

        uibModal.open({
          backdrop: true,
          keyboard: true,
          backdropClick: true,
          templateUrl: "partials/reporting/dialog_report.html",
          controller: "AddReportModalCtrl",
          scope: scope,
          resolve: {
            project: () => scope.project,
            config: () => {
              return {
                type: "post_processing_report",
                format: "zip",
                name: "Post Processing Report " +
                  (currentDate.getMonth() + 1) + "/" +
                  currentDate.getDate() + "/" +
                  currentDate.getFullYear() + " @ " +
                  currentDate.getHours() + ":" +
                  currentDate.getMinutes() + ":" +
                  currentDate.getSeconds(),
                fields: []
              };
            },
            formConfig: () => {
              return {
                hideFields: true
              }
            },
            collections: null,
            search: null,
            filter: () => scope.cookieFilter
          }
        });
      };

      postProcessingService.GetAllMetrics(routeParams.projectId).then(data => {
        scope.chart = {};
        scope.chart.resourceCounts = data.documentCountByDate;
        scope.chart.start = data.startDate;
        scope.chart.end = data.endDate;
        scope.postprocessing = {...scope.postprocessing, ...data};
      });

      preProcessingService.GetAllMetrics(routeParams.projectId).then(data => {
        scope.preprocessing = {...scope.preprocessing, ...data};
        scope.projectSourceSize = {
          value: data.projectSourceSize,
          total: data.projectSourceSize + data.projectOutputSize
        };
        scope.projectOutputSize = {
          value: data.projectSourceSize + data.projectOutputSize,
          total: data.projectSourceSize + data.projectOutputSize
        };
      });

      this.Initialize(scope);

      rootScope.$on("tags.fetch", () => {
        this.FetchTags(scope, 1);
        ProjectDetailController.FetchBatches(scope);
      });

      scope.$watchCollection("collections", () => {
        scope.processingCollections = _.filter(scope.collections, (c: ICollection) => c.status !== CollectionStatus.Processed);
        scope.showProcessingCollections = scope.processingCollections && scope.processingCollections.length > 0;
      });

      scope.$watch("tagPagination.categoryId", val => {
        if (val) {
          tagCategoryService.findById(val, category => scope.tagPagination.category = category);

          this.FetchTags(scope, 1);
        }
      });

      scope.$watch("tagPagination", val => val && this.FetchTags(scope, val.page));

      scope.$watch("tagPagination.page", val => val && this.FetchTags(scope, val));

      scope.$watch("[review.begin, review.end]", () => {
        if (scope.project && scope.review.begin > 0 && scope.review.end > 0) {
          projectService.SetReviewDateRange(scope.project, new Date(scope.review.begin), new Date(scope.review.end)).then(() => {
            reviewService.GetReviewStatistics(scope.project.id).then(response => {
              type Info = {
                date: Date,
                idealResourcesRemaining: number,
                actualResourcesRemaining: number,
                idealBurnRate: number,
                actualBurnRate: number,
              };

              const statistics: Array<Info> = [];

              for (let date in response.statistics) {
                if (response.statistics.hasOwnProperty(date)) {
                  const stats = response.statistics[date];

                  statistics.push({
                    date: moment(date).local().valueOf(),
                    idealResourcesRemaining: stats.idealResourcesRemaining,
                    actualResourcesRemaining: stats.actualResourcesRemaining,
                    idealBurnRate: stats.idealBurnRate,
                    actualBurnRate: stats.actualBurnRate,
                  });
                }
              }

              const groupedStatistics = _.groupBy(statistics, s => moment.utc(s.date).local().startOf("day"));
              const flattenedStatistics = _.map(groupedStatistics, g => {
                return {
                  date: _.last(g).date,
                  idealResourcesRemaining: _.last(g).idealResourcesRemaining,
                  actualResourcesRemaining: _.last(g).actualResourcesRemaining,
                  idealBurnRate: _.last(g).idealBurnRate,
                  actualBurnRate: _.map(g, g => g.actualBurnRate).reduce((a, b) => a + b)
                };
              });

              this.$timeout(() => {
                scope.review.rows = _.flatten(["x", _.map(flattenedStatistics, v => v.date)]);
                scope.review.columns = [
                  _.flatten(["Target Burn Down", _.map(flattenedStatistics, v => v.idealResourcesRemaining)]),
                  _.flatten(["Total Items Remaining", _.map(flattenedStatistics, v => v.actualResourcesRemaining)]),
                  _.flatten(["Daily Review Target", _.map(flattenedStatistics, v => v.idealBurnRate)]),
                  _.flatten(["Reviewed", _.map(flattenedStatistics, v => v.actualBurnRate)])
                ];
                scope.review.types = {
                  "Target Burn Down": "line",
                  "Total Items Remaining": "line",
                  "Daily Review Target": "step",
                  "Reviewed": "bar"
                };

                scope.review.lastRecordedDate = moment(response.lastRecordedDate).startOf("day").toDate().valueOf();
              });

            });
          });
        }
      });

      // Snag the first tag category and use it to fetch the first page of tags
      tagCategoryService.findAll(categories => {
        scope.tagCategories = _.filter(categories, (category: any) => category.name !== "Batch");

        const firstCategory: any = _.first(categories);

        scope.tagPagination.category = firstCategory;
        scope.tagPagination.categoryId = firstCategory.id;
      });

      rootScope.$on("FeedService.BatchAssigned", () => ProjectDetailController.FetchBatches(scope));

      exportService.FindAll({projectId: routeParams.projectId}).then(exports => this.$timeout(() => scope.exports = exports));

      scope.$on("ExportService.update", (evt, projectId, exports) => {
        if (scope.project.id === projectId) {
          if (exports.length === 1) {
            scope.exports.unshift(exports[0]);
          } else {
            this.$timeout(() => {
              scope.exports = exports;
              const exportInstance: any = _.findWhere(scope.exports, {id: scope.exportId});
              if (exportInstance) {
                exportInstance.endBates = scope.endBates;
              }
              scope.exportId = undefined;
              scope.endBates = undefined;
            });
          }
        }
      });

      scope.$watch("reportPagination.currentPage", (newValue) => {
        if (newValue) {
          scope.getReportsForList();
        }
      }, true);

      // Refresh the list when a report finishes
      scope.$on("FeedService.ReportComplete", () => scope.getReportsForList());
      scope.$on("FeedService.BatesCaptureComplete", (event: any, message: { exportId: string, endBates: string }) => {
        scope.endBates = message.endBates;
        scope.exportId = message.exportId;
      });

      scope.$on("FeedService.ProcessingPaused", (event, message) => {
        (_.findWhere(scope.collections, {id: message.id}) as ICollection).status = CollectionStatus.Paused;
      });

      scope.$on("FeedService.CollectionUpdate", (event, message) => {
        const index = _.findIndex(scope.collections as ICollection[], c => c.id === message.collectionId);
        if (index < 0) { return; }

        scope.collections[index].status = message.status;
        scope.collections[index].numQueued = message.numQueued;
        scope.collections[index].numProcessed = message.numProcessed;
        scope.collections[index].bytesProcessed = message.bytesProcessed;
        scope.collections[index].processingSource = message.processingSource;
        scope.collections[index].processingOutput = message.processingOutput;
        scope.collections[index].job.percentageComplete = message.percentageComplete;

        if (message.status === CollectionStatus.Processed) {
          scope.processingCollections = _.filter(scope.collections, (c: ICollection) => c.status !== CollectionStatus.Processed);
          scope.showProcessingCollections = scope.processingCollections && scope.processingCollections.length > 0;
        }
      });

      scope.$on("chartItemSelected", (e, sender, item) => {
        if (sender.attr("id").indexOf("collection") >= 0 || sender.attr("id").indexOf("custodian") >= 0) {
          scope.showFilteredCollections(item);
        } else if (sender.attr("id").indexOf("extension") >= 0) {
          rootScope.$broadcast("BasicSearch.Triggered", `fileExtension:"${item.id}"`);
        } else if (sender.attr("id").indexOf("category") >= 0) {
          rootScope.$broadcast("BasicSearch.Triggered", `category:"${item.id}"`);
        } else if (sender.attr("id").indexOf("emailDomain") >= 0) {
          rootScope.$broadcast("BasicSearch.Triggered", `emailDomains:"${item.id}"`);
        } else if (sender.attr("id").indexOf("systemTagChart") >= 0) {
          rootScope.$broadcast("BasicSearch.Triggered", `systemTags:"${item.id}"`);
        } else if (sender.attr("id").indexOf("resourceEntities") >= 0) {
          rootScope.$broadcast("BasicSearch.Triggered", `${item.type}Entities.lowercase:"${item.id}"`);
        } else if (sender.attr("id").indexOf("reviewedChart") >= 0) {
          rootScope.$broadcast("ReviewedChart.Triggered", item);
        } else if (sender.attr("id").indexOf("notReviewedChart") >= 0) {
          rootScope.$broadcast("NotReviewedChart.Triggered", item);
        } else if (sender.attr("id").indexOf("timeline") >= 0) {
          rootScope.$broadcast("BasicSearch.Triggered", "createdDate:" + app.services.search.basic.SearchService.FormatDateSearch(item));
        }
      });

      rootScope.$on("TagSaved", () => scope.tagPagination = {...scope.tagPagination, page: 1});
    }

    private async Initialize(scope) {

      const project = await this.projectService.FindOne({id: this.routeParams.projectId}, false);

      scope.project = project;
      scope.canManageBatches = this.roleService.hasPermission(project.roles, "MANAGE_BATCHES");
      scope.collections = project.collections;
      scope.custodians = project.custodians;

      this.collectionService.CacheCollections(project.collections);
      this.WriteCollectionStats(scope, scope.collections);
      this.SaveSelectedCollections(scope);
      this.projectService.SetCurrentProject(project);
      await this.LoadOrganizations(project);

      if (this.roleService.hasPermission(project.roles, "REVIEW_MANAGEMENT")) {
        const statistics = await this.reviewService.GetReviewStatistics(project.id);

        this.$timeout(() => {
          scope.review.begin = moment.tz(moment.utc(statistics.begin), moment.tz.guess()).valueOf();
          scope.review.end = moment.tz(moment.utc(statistics.end), moment.tz.guess()).valueOf();
        })
      }

      scope.columnDefinitions = [
        {
          headerName: "Batch",
          colId: "batchName",
          filter: false,
          sortable: false,
          width: 170,
          pinnedRowCellRenderer: _ => "",
          cellRenderer: params => {
            if (params.data) {
              return `<a href="#!/project/${scope.project.id}/home/batch/${params.data.id}">${params.data.name}</a>`;
            }
          }
        },
        {
          headerName: "Assigned To",
          colId: "assignedTo",
          filter: false,
          sortable: false,
          width: 400,
          hide: !this.roleService.hasPermission(scope.project.roles, "MANAGE_BATCHES"),
          cellRenderer: params => {
            if (params.data) {
              return `<td>
                        <span class="badge badge-info" ng-repeat="user in data.users">
                            <i class="fas fa-user"></i>
                            {{ user.name }}
                        </span>
                        <span class="badge badge-info" ng-repeat="role in data.roles">
                            <i class="fas fa-users"></i>
                            {{ role.name }}
                        </span>
                    </td>`;
            }
          }
        },
        {
          headerName: "Total Items",
          field: "totalItems",
          colId: "totalItems",
          filter: false,
          sortable: false,
          pinnedRowCellRenderer: params => params.data.totalItems,
          width: 130,
          valueFormatter: params => params.value ? d3.format(",d")(params.value) : ""
        },
        {
          headerName: "Reviewed",
          colId: "reviewed",
          filter: false,
          sortable: false,
          width: 130,
          pinnedRowCellRenderer: params => params.data.totalReviewed,
          cellRenderer: params => {
            if (params.data) {
              return `<a href="#!/project/${scope.project.id}/home/batch/${params.data.id}/reviewed">${params.data.numReviewed}`;
            }
          }
        },
        {
          headerName: "Not Reviewed",
          colId: "notReviewed",
          filter: false,
          sortable: false,
          width: 130,
          pinnedRowCellRenderer: params => params.data.totalNotReviewed,
          cellRenderer: params => {
            if (params.data) {
              return `<a href="#!/project/${scope.project.id}/home/batch/${params.data.id}/notReviewed">${params.data.numNotReviewed}`;
            }
          }
        },
        {
          headerName: "Progress",
          colId: "progress",
          filter: false,
          sortable: false,
          width: 200,
          pinnedRowCellRenderer: params => `<div class="progress" style="margin-top: 7px">
                          <div class="progress-bar" style="width: ${(params.data.totalReviewed / (params.data.totalReviewed + params.data.totalNotReviewed)) * 100}%">
                              ${d3.format(",d")(Math.floor(params.data.totalReviewed / (params.data.totalReviewed + params.data.totalNotReviewed) * 100))}%
                          </div>
                      </div>`,
          cellRenderer: params => {
            if (params.data) {
              return `<div class="progress" style="margin-top: 7px">
                          <div class="progress-bar" style="width: ${(params.data.numReviewed / (params.data.numReviewed + params.data.numNotReviewed)) * 100}%">
                              ${d3.format(",d")(Math.floor(params.data.numReviewed / (params.data.numReviewed + params.data.numNotReviewed) * 100))}%
                          </div>
                      </div>`;
            }
          }
        },
        {
          headerName: "Actions",
          colId: "actions",
          filter: false,
          sortable: false,
          hide: !this.roleService.hasPermission(scope.project.roles, "MANAGE_BATCHES"),
          pinnedRowCellRenderer: _ => "",
          cellRenderer: params => {
            if (params.data) {
              return `
                  <button ng-show="data.status != 'Deleting'" type="button" class="btn btn-default btn-xs"
                          ng-click="$parent.$parent.$parent.$parent.$parent.openAssignBatchDialog(data)"
                          ng-class="{ 'active': tt_isOpen }">
                      <i class="fas fa-share"></i> Assign
                  </button>
                  <button ng-show="data.status != 'Deleting'" type="button" class="btn btn-default btn-xs"
                          ng-click="$parent.$parent.$parent.$parent.$parent.openAddTagDialog(data)"
                          ng-class="{ 'active': tt_isOpen }">
                      <i class="fas fa-pencil-alt"></i> Edit
                  </button>
                  <button ng-show="data.status != 'Deleting'" type="button" class="btn btn-xs btn-danger"
                          ng-click="$parent.$parent.$parent.$parent.$parent.removeTag(data)">
                      <i class="fas fa-trash"></i>
                      Delete
                  </button>
                  <span ng-show="data.status == 'Deleting'" class="label label-warning" style="font-size: 12px">
                      <i class="fas fa-trash"></i>
                      Deleting
                      <i class="fas fa-spinner fa-pulse"></i>
                  </span>
              `;
            }
          }
        }
      ];

      scope.dataSource = {
        rowCount: null,
        getRows: (params: agGrid.IGetRowsParams) => {
          this.batchService.GetAll(this.routeParams.projectId, Math.floor(params.startRow / scope.batchPagination.limit), scope.batchPagination.limit).then((page: any) => {
            scope.batchPagination.totalBatches = page.totalBatches;
            scope.batchPagination.totalPageCount = page.totalPageCount;
            scope.batchPagination.pinnedTopRowData = [{
              totalReviewed: page.totalReviewed,
              totalNotReviewed: page.totalNotReviewed,
              totalItems: page.totalItems
            }];
            scope.batchPagination.pinnedBottomRowData = [{
              totalReviewed: page.totalReviewed,
              totalNotReviewed: page.totalNotReviewed,
              totalItems: page.totalItems
            }];
            params.successCallback(page.batches, page.totalBatches);
          });
        }
      };
    }

    private async LoadOrganizations(project) {
      if (project.type === "organization_project") {
        const organization = await this.organizationService.FindOne({ id: project.organizationId });
        this.$timeout(() => {
          this.scope.organization = organization;
          this.organizationService.SetCurrentOrganization(organization);
        });
      } else {
        this.$timeout(() => {
          this.organizationService.ClearCurrentOrganization();
        });
      }
    }

    private async DeleteAndRefreshTags(tag) {

      const _ = await this.tagService.DeleteTag(tag instanceof Tag ? tag : new Tag(tag.projectId, tag.id));

      this.$timeout(() => {
        this.FetchTags(this.scope, 1);
        ProjectDetailController.FetchBatches(this.scope);
        this.scope.$applyAsync();
      });
    }

    private FetchTags(scope, page) {
      if (!page) {
        page = scope.tagPagination.page;
      } else if (page !== scope.tagPagination.page) {
        scope.tagPagination.page = page;
      }

      if (scope.tagPagination.categoryId) {
        this.tagService.GetAll(
          this.routeParams.projectId,
          scope.tagPagination.categoryId,
          page - 1,
          scope.tagPagination.limit,
          tagPage => {
            scope.tagsPage = tagPage;
            scope.tagPagination.totalTags = tagPage.totalTags;
            scope.tagPagination.totalPages = tagPage.totalPages;
          }
        );
      }
    }

    private static FetchBatches(scope) {
      scope.dataSource = {...scope.dataSource};
    }

    private WriteCollectionStats(scope, collections?: Array<Collection>) {
      scope.postprocessing.collectionFiles = [];
      scope.postprocessing.collectionSizes = [];
      scope.postprocessing.custodianSizes = [];
      scope.postprocessing.custodianFiles = [];
      scope.postprocessing.custodianNames = [];

      const custodians = {};

      if (collections) {
        collections.forEach(collection => {

          const processingSource = collection.processingSource || {bytes: 0, files: 0};
          const processingOutput = collection.processingOutput || {bytes: 0, files: 0};

          const combinedBytes = processingSource.bytes + processingOutput.bytes;
          const combinedFiles = processingSource.files + processingOutput.files;

          scope.postprocessing.collectionSizes.push({label: collection.name, value: combinedBytes});
          scope.postprocessing.collectionFiles.push({label: collection.name, value: combinedFiles});

          // keep a map of the custodian bytes
          if (_.has(custodians, collection.custodian.name)) {
            custodians[collection.custodian.name].bytes += combinedBytes;
            custodians[collection.custodian.name].files += combinedFiles;
          } else {
            custodians[collection.custodian.name] = {
              bytes: combinedBytes,
              files: combinedFiles
            };
          }
        });
      }

      // now add our custodian data
      angular.forEach(custodians, (obj: any, custodian) => {
        scope.postprocessing.custodianSizes.push({label: custodian, value: obj.bytes});
        scope.postprocessing.custodianFiles.push({label: custodian, value: obj.files});
      });

      scope.custodianNames = _.keys(custodians);
    }

    private SaveSelectedCollections(scope) {
      const filteredCollections = this.filter("filter")(scope.collections, {checked: true});

      scope.numFilteredCollections = filteredCollections.length;

      this.preferenceService.SelectedCollections = filteredCollections;
    }
  }

  frontendApp.controller("ProjectDetailController", ["$rootScope", "$scope", "$routeParams",
    "$uibModal", "$location", "$timeout", "$filter", "PreferenceService", "ProjectService",
    "OrganizationService", "CollectionService",
    "ExportService", "TagService",
    "TagCategoryService", "ExportDownloadService",
    "NavigationService", "ReportService", "PreProcessingMetricsService",
    "PostProcessingMetricsService", "NotificationService", "AccountService", "RoleService", "BatchService", "ReviewService", "ProcessingService", Factory.Create(ProjectDetailController)]);
}
